export const ENTRYPOINT_ROOT = process.env.REACT_APP_ENTRYPOINT_ROOT;
export const ENTRYPOINT = ENTRYPOINT_ROOT+"/api/";
